module.exports = __webpack_public_path__ + "img/Number=71.9915a817.png";